import React from "react";
import { TextField } from "@mui/material";
//This component takes numeric string as input value
const NewNumberInput = (props) => {
  const {
    onChangeValue,
    value = "",
    allowNegative = false,
    decimals = 0,
    ...otherProps
  } = props;

  return (
    <TextField
      inputProps={{
        inputMode: "numeric",
        // pattern: "[0-9]*",
        pattern: "^-?[0-9]+([.][0-9]+)?",
      }}
      onKeyDown={(e) => {
        if (/^\d+$/.test(e.key)) {
          const valueStr = `${value}`;
          if (decimals > 0) {
            const valueStrNoDot = valueStr.replace(".", "");
            const newValueStr = `${valueStrNoDot}${e.key}`;
            const newValue = (Number(newValueStr) / 100).toFixed(2);
            onChangeValue(newValue);
          } else {
            const newValueStr = `${value}${e.key}`;
            onChangeValue(Number(newValueStr));
          }
        } else if (e.key === "Backspace") {
          const strArr = `${value}`.split("");
          strArr.pop();
          const str = strArr.join("");
          if (isNaN(str)) {
            onChangeValue(0);
          } else {
            onChangeValue(Number(str));
          }
        } else if (
          ["-", "Minus", "NumpadSubtract"].includes(e.code) &&
          allowNegative
        ) {
          const valueStr = `${value}`;
          onChangeValue(Number(valueStr) * -1);
        }
      }}
      value={value}
      {...otherProps}
    />
  );
};

export default NewNumberInput;
